module.exports = __webpack_public_path__ + "img/interface OneB Player_4.3df65d4c.jpg";